import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Header from "../../shared/header/Header";
import { Helmet } from "react-helmet";
import styles from "./RequestProduct.module.scss";
import { requestProduct } from "../../../redux/dispatchers/requestProductDispatcher";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import { CTA_COLOUR } from "../../../utils/constants/others";
import Cross from "sushiweb/Icons/all/Cross";
import {
  getReqSearchSuggestions,
  searchProductsForBuyerWithQuery,
  clearSuggestion,
} from "../../../redux/dispatchers/catalogDispatcher";
import {
  setErrorToast
} from "../../../redux/dispatchers/userDispatcher";
import { debounce } from "../../../utils/helpers";
import { getUserData } from "../../../redux/dispatchers/userDispatcher";
import ChevronRight from "sushiweb/Icons/all/ChevronRight";
import RequestSuccessModal from "./requestSuccessModal/RequestSuccessModal";
import SuggestionModal from "./suggestionModal/SuggestionModal";
import Toast from "sushiweb/Toast/Toast";
import queryString from "query-string";
import { usePrevious } from "../../../utils/helpers";
import stateTypes from "../../../utils/constants/stateTypes";
import CrossCircleFill from "sushiweb/Icons/all/CrossCircleFill";
import { ToastHandler } from "../../shared/Toast/ToastHandler";

const initialState = {
  form: {
    searchText: "",
    detail: "",
  },
  modal: {
    success: false,
    suggestions: false,
  },
  toast: {
    show: false,
    text: "",
    type: "default",
  },
};

export const RequestProduct = ({
  actions,
  searchSuggestions,
  requestProductStatus,
  userData,
  history,
  location,
  searchProductsForBuyer,
  searchProductsForBuyerStatus,
  dispatch,
}) => {
  const [form, setform] = useState(initialState.form);
  const [modal, setModal] = useState(initialState.modal);
  const [showSuggestion, setShowSuggestion] = useState(true);
  const [toast, setToast] = useState(initialState.toast);
  useEffect(()=>{
    if (toast.show && toast.text) {
      actions.setErrorToast(toast.text)
    }
  },[toast])
  const prevRequestProductStatus = usePrevious(requestProductStatus.state);
  const prevSearchStatus = usePrevious(searchProductsForBuyerStatus.state);

  let autoSuggestAPI = debounce(actions.getReqSearchSuggestions, 500);

  const locationData = queryString.parse(location.search);
  const { source, searchText } = locationData;

  function setField(key, value) {
    setform({
      ...form,
      [key]: value,
    });
    if (key === "searchText") {
      if (!value || value.length < 3) {
        setShowSuggestion(false);
      }
      if (
        value.length >= 3 &&
        ["listing", "side_menu"].includes(source)
      ) {
        autoSuggestAPI(value);
        setShowSuggestion(true);
      }
    }
  }

  function showModal(type, status) {
    setModal({
      ...modal,
      [type]: status,
    });
  }

  useEffect(() => {
    if (searchText) {
      setField("searchText", searchText);
    }
    return () => actions.clearSuggestion();
  }, []);

  useEffect(() => {
    if (prevRequestProductStatus !== requestProductStatus.state) {
      if (
        prevRequestProductStatus === stateTypes.STATE_BEGIN &&
        requestProductStatus.state === stateTypes.STATE_DONE
      ) {
        showModal("success", true);
      } else if (
        prevRequestProductStatus === stateTypes.STATE_BEGIN &&
        requestProductStatus.state === stateTypes.STATE_FAIL
      ) {
        toastOpenHandler({
          show: true,
          text: "error requesting product",
          type: "error",
        });
      }
    }
  }, [requestProductStatus.state]);

  useEffect(() => {
    if (prevSearchStatus !== searchProductsForBuyerStatus.state) {
      if (
        prevSearchStatus === stateTypes.STATE_BEGIN &&
        searchProductsForBuyerStatus.state === stateTypes.STATE_DONE
      ) {
        showModal("suggestions", true);
      }
    }
  }, [searchProductsForBuyerStatus.state]);

  function handleSubmit() {
    //TODO: call api
    actions.requestProduct({
      Comments: form.detail,
      Keyword: form.searchText,
      Source: source,
    },()=>{})
  }

  function handleDismiss() {
  
    if (history){
      history.push("/");
    } else {
      return 
    }

  }

  function handleSuggestionClose() {
    showModal("suggestions", false);
  }

  function toastOpenHandler({ show, text, type }) {
    setToast({
      ...toast,
      show,
      text,
      type,
    });
  }

  function toastCloseHandler() {
    setToast({
      ...toast,
      ...initialState.toast,
    });
  }

  function openSimilarModal() {
    //fetch data , when data fetching is complete show modal with suggestions
    const {
      action: {
        ActionData: {
          SearchQuery = ""
        } = {}
      } = {}
    } = searchSuggestions || {}
    actions.searchProductsForBuyerWithQuery(
      `?${SearchQuery}`,
      1,
      true,
      false,
      true
    );
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Request Product | Hyperpure</title>
      </Helmet>
      <Header />
      <RequestSuccessModal visible={modal.success} onClose={handleDismiss} />
      {modal.suggestions && (
        <SuggestionModal
          visible={true}
          suggestionStatus={searchProductsForBuyerStatus}
          suggestions={
            searchProductsForBuyer && searchProductsForBuyer.products
          }
          toastOpenHandler={toastOpenHandler}
          onClose={handleSuggestionClose}
          title={`${searchProductsForBuyer?.products?.length} products similar to ${form.searchText}`}
          cartUpdateSource={"REQUEST_PRODUCT"}
        />
      )}
      <main className="site-content pd-top-global-large">
        <section className="container mb-4">
          <div className={styles.header}>Request a product</div>
          <div className="line-light"></div>
          <div className={`${styles.description} w-600`}>
            Tell us if you can’t find a product and we will add it to the shop
            as soon as possible.
          </div>
          <Input
            hideLabel
            value={form.searchText}
            innerWidth="513px"
            label="Enter product name"
            onChange={(value) => setField("searchText", value)}
            icon={
              form.searchText ? (
                <CrossCircleFill
                  className="pointer"
                  size={16}
                  onClick={() => setField("searchText", "")}
                />
              ) : null
            }
          />
          {/* {showSuggestion &&
            ["listing", "side_menu"].includes(source) &&
            searchSuggestions.productCount && (
              <div className={styles.similarContainer}>
                <div className={styles.arrow}></div>
                <div className={styles.textBox}>
                  <div className="d-flex justify-content-between mb-3">
                    <div className="fs-16 w-400 text-gray-900">
                      We found {searchSuggestions.productCount} similar products
                      in the shop
                    </div>
                    <Cross
                      size={20}
                      className="pointer"
                      color="#696969"
                      onClick={() => setShowSuggestion(false)}
                    />
                  </div>
                  <div
                    className="d-flex align-items-center"
                    onClick={openSimilarModal}
                  >
                    <div className="text-red-600 fs-16 w-600 mr-2 pointer">
                      View similar
                    </div>
                    <ChevronRight size={20} color={CTA_COLOUR} />
                  </div>
                </div>
              </div>
            )} */}
          <div className="my-4 fs-18 text-gray-900 w-600">
            Tell us more about the product{" "}
            <span className="text-gray-600">(optional)</span>
          </div>
          <Input
            hideLabel
            value={form.detail}
            innerWidth="513px"
            label="Add brand name, pack size, expected price..."
            onChange={(value) => setField("detail", value)}
          />
          <div className={styles.btnContainer}>
            <Button
              btnColor={CTA_COLOUR}
              className={`mr-4 w-400 ${form.searchText ? 'solid': ''}`}
              onClick={handleSubmit}
              disabled={!form.searchText}
            >
              Submit
            </Button>
            <Button btnColor="red" appearance="outline" onClick={handleDismiss}>
              <span className="w-400">Dismiss</span>
            </Button>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
};

export default withRouter(
  connect(
    (state) => ({
      //data
      searchSuggestions: state.catalog.requestProductSuggestion || {},
      searchProductsForBuyer: state.catalog.searchProductsForBuyer || {},
      userData: state.user.data || {},
      //status
      searchSuggestionsStatus: state.status.request_getSearchSuggestions,
      requestProductStatus: state.status.requestProduct,
      searchProductsForBuyerStatus: state.status.catalog_searchProductsForBuyer,
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          requestProduct,
          getReqSearchSuggestions,
          searchProductsForBuyerWithQuery,
          getUserData,
          clearSuggestion,
          setErrorToast
        },
        dispatch
      ),
      dispatch,
    })
  )(RequestProduct)
);
